angular.module('app.services').service('notify', ($rootScope) => {
    let config = {
        timeoutFlash: 2000,
        timeoutDefault: 5000,
        timeoutLong: 10000,
        timeoutVeryLong: 30000,
    };

    return {
        config(key) {
            return config[key] || null;
        },

        info(content, timeout, position) {
            return UIkit.notify({
                message: content,
                status: 'info',
                timeout: timeout || config.timeoutDefault,
                pos: position || 'bottom-right',
            });
        },

        success(content, timeout, position) {
            return UIkit.notify({
                message: content,
                status: 'success',
                timeout: timeout || config.timeoutDefault,
                pos: position || 'bottom-right',
            });
        },

        warning(content, timeout, position) {
            return UIkit.notify({
                message: content,
                status: 'warning',
                timeout: timeout || config.timeoutDefault,
                pos: position || 'bottom-right',
            });
        },

        danger(content, timeout, position) {
            return UIkit.notify({
                message: content,
                status: 'danger',
                timeout: timeout || config.timeoutDefault,
                pos: position || 'bottom-right',
            });
        },

        global(status) {
            return status ? $rootScope.content_preloader_show() : $rootScope.content_preloader_hide();
        },

        overlay(status) {
            let $overlay = angular.element('body > .notify-overlay');

            if (!$overlay.length) {
                $overlay = angular.element('<div class="notify-overlay"></div>');
                angular.element('body').append($overlay);
            }

            if (status) {
                $overlay.addClass('show');
            } else {
                $overlay.removeClass('show');
            }
        },
    };
});
